// ============ ProjectDetail.jsx ============
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import api from "../hooks/useApi";

export function ProjectDetail() {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [activeImg, setActiveImg] = useState(0);

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const res = await api.getProject(id);

        console.log("PROJECT DETAIL:", res);

        const data =
          res.data && typeof res.data === "object"
            ? res.data
            : res.data?.data || null;

        if (data) {
          setProject(data);
        } else {
          console.warn("Invalid project data");
          setProject(null);
        }
      } catch (err) {
        console.error("PROJECT DETAIL ERROR:", err?.response || err.message);
        setProject(null);
      }
    };

    fetchProject();
  }, [id]);

  if (!project)
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "60vh",
          color: "#8A8070",
        }}
      >
        Loading project...
      </div>
    );

  return (
    <>
      <Helmet>
        <title>{project.title} — NirmalRam Construction</title>
      </Helmet>
      <section
        style={{
          paddingTop: "8rem",
          paddingBottom: "4rem",
          background: "#0A0A0A",
          borderBottom: "1px solid rgba(201,168,76,0.1)",
        }}
      >
        <div className="container">
          <Link
            to="/projects"
            style={{
              color: "#8A8070",
              fontSize: "0.85rem",
              display: "inline-flex",
              alignItems: "center",
              gap: "0.5rem",
              marginBottom: "2rem",
            }}
          >
            ← Back to Projects
          </Link>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 380px",
              gap: "3rem",
              alignItems: "start",
            }}
          >
            <div>
              {/* Image gallery */}
              <div
                style={{
                  height: "420px",
                  background: "#111",
                  borderRadius: "3px",
                  overflow: "hidden",
                  marginBottom: "1rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "5rem",
                  position: "relative",
                }}
              >
                {project.images?.[activeImg]?.url ? (
                  <img
                    src={project.images[activeImg].url}
                    alt={project.title}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  "🏠"
                )}
              </div>
              {project.images?.length > 1 && (
                <div
                  style={{ display: "flex", gap: "0.75rem", overflowX: "auto" }}
                >
                  {project.images.map((img, i) => (
                    <div
                      key={i}
                      onClick={() => setActiveImg(i)}
                      style={{
                        width: "80px",
                        height: "60px",
                        borderRadius: "2px",
                        overflow: "hidden",
                        cursor: "pointer",
                        border:
                          i === activeImg
                            ? "2px solid #C9A84C"
                            : "1px solid rgba(201,168,76,0.1)",
                        flexShrink: 0,
                        background: "#111",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {img.url && (
                        <img
                          src={img.url}
                          alt=""
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div>
              <span
                className={`badge ${project.status === "Completed" ? "badge-green" : "badge-gold"}`}
                style={{ marginBottom: "1rem" }}
              >
                {project.status}
              </span>
              <h1
                style={{
                  fontFamily: "Cormorant Garamond,serif",
                  fontSize: "2.2rem",
                  marginBottom: "1rem",
                }}
              >
                {project.title}
              </h1>
              <p
                style={{
                  color: "#8A8070",
                  lineHeight: 1.8,
                  marginBottom: "2rem",
                }}
              >
                {project.description}
              </p>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "1rem",
                  marginBottom: "2rem",
                }}
              >
                {[
                  ["Location", project.location],
                  ["Type", project.type],
                  ["Year", project.year],
                  ["Area", project.area],
                  ["Budget", project.budget || "On Request"],
                  ["Client", project.client || "Private"],
                ].map(
                  ([k, v]) =>
                    v && (
                      <div
                        key={k}
                        style={{
                          background: "#111",
                          border: "1px solid rgba(201,168,76,0.1)",
                          padding: "1rem",
                          borderRadius: "2px",
                        }}
                      >
                        <div
                          style={{
                            fontSize: "0.7rem",
                            color: "#5A5450",
                            letterSpacing: "1.5px",
                            textTransform: "uppercase",
                            marginBottom: "0.25rem",
                          }}
                        >
                          {k}
                        </div>
                        <div style={{ color: "#F0EAE0", fontSize: "0.95rem" }}>
                          {v}
                        </div>
                      </div>
                    ),
                )}
              </div>
              {project.features?.length > 0 && (
                <div style={{ marginBottom: "2rem" }}>
                  <h4
                    style={{
                      fontFamily: "Cormorant Garamond,serif",
                      fontSize: "1.1rem",
                      marginBottom: "0.75rem",
                      color: "#C9A84C",
                    }}
                  >
                    Key Features
                  </h4>
                  {project.features.map((f) => (
                    <div
                      key={f}
                      style={{
                        display: "flex",
                        gap: "0.5rem",
                        marginBottom: "0.4rem",
                      }}
                    >
                      <span style={{ color: "#C9A84C" }}>◆</span>
                      <span style={{ color: "#8A8070", fontSize: "0.9rem" }}>
                        {f}
                      </span>
                    </div>
                  ))}
                </div>
              )}
              <Link to="/contact" className="btn-gold">
                Build Something Similar →
              </Link>
            </div>
          </div>
        </div>
        <style>{`@media(max-width:900px){.container>div[style*="grid-template-columns: 1fr 380px"]{grid-template-columns:1fr!important;}}`}</style>
      </section>
    </>
  );
}

export default ProjectDetail;
